import React from "react";
import PropTypes from 'prop-types';
import './popup.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Popup = props => {
  const {content, handleClose, isClose} = props
  return (
   
      <div className="models-box">
        {isClose && <span className="close-icon" onClick={handleClose}>x</span> }
        {content}
      </div>
   
  );
};
Popup.propTypes = {
  handleClose: PropTypes.func,
  content: PropTypes.string,
  isClose: PropTypes.bool, 
}
 
export default Popup;